import { UnauthorizedPage } from '@src/pages/Unauthorized';
import { GCashAuthContextProvider } from '@src/Providers/GCashAuthContextProvider';
import { envConfig } from '@src/utils/envConfig';
import { isGCashEnv } from '@src/utils/isGCashEnv';
import { AuthContextProvider, PortalContextProvider } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { ErrorBoundaryRouted } from './components/ErrorBoundary';
import { EssentialProviders, Providers } from './Providers';

const AppAuthContextProvider = isGCashEnv
  ? GCashAuthContextProvider
  : (props: PropsWithChildren<unknown>) => {
      return (
        <AuthContextProvider
          {...props}
          loginUrl={envConfig.VITE_AUTH_LOGIN_URL}
          logoutUrl={envConfig.VITE_AUTH_LOGOUT_URL}
          sessionCookieName={envConfig.VITE_SESSION_COOKIE}
        />
      );
    };

function AppInner() {
  return (
    <PortalContextProvider>
      <Routes>
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route
          path="*"
          element={
            <AppAuthContextProvider>
              <EssentialProviders>
                <Providers>
                  <AppRoutes />
                </Providers>
              </EssentialProviders>
            </AppAuthContextProvider>
          }
        />
      </Routes>
    </PortalContextProvider>
  );
}

const browserRouter = createBrowserRouter([
  { path: '*', element: <AppInner />, errorElement: <ErrorBoundaryRouted /> },
]);

export function GCashApp() {
  return <RouterProvider router={browserRouter} />;
}

export default GCashApp;
